<div class="content p-5">
    <h1>{{dialogData.title}}</h1>
    <p>{{dialogData.content}}</p>
    <div class="columns mt-3">
        <div class="column is-5">
            <a class="button back-button has-round-border" (click)="reject()" style="border: none; display: block !important; color: white;">
                <div class="columns" style="align-items: center; justify-content: center; padding-top: 5px;">
                    <div class="column is-one-fifth pr-0" >
                        <img alt="Arrow Left" src="assets/images/button/left_btn.svg">
                    </div>
                    <div class="column is-bold">
                        <p style="padding-bottom: 10px;">Abbrechen</p>
                    </div>
                </div>
            </a>
        </div>
        <div class="column is-5 is-offset-2">
            <a class="button buy-button has-round-border" (click)="confirm()" style="border: none; display: block !important; color: white;">
                <div class="columns" style="align-items: center; justify-content: center; padding-top: 5px;">
                    <div class="column is-bold">
                        <p style="padding-bottom: 10px;">Bestätigen</p>
                    </div>
                    <div class="column is-one-fifth pl-0" >
                        <img alt="Arrow Right" src="assets/images/button/right_btn.svg">
                    </div>
                </div>
            </a>
        </div>
    </div>
</div>
